export default {
  emailtemplates: [],
  pagination: {},
  emailtemplate: {}
}
